import axios from "axios"
import router from '../../router'
import common from '@/assets/js/api'
import { Toast } from 'vant'
// import qs from 'qs'
const BASE_API = ''//服务器
const service = axios.create({
  baseURL: BASE_API,
})
service.interceptors.request.use(
  config => {
    // console.log(config)
    if(config.url.indexOf(common.gzh) != -1) {

    }else {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration:0
      });
    }
    
    // config.headers["Authorization"] = localStorage.getItem('authToken')
    // config.headers["businessid"] = '1505713677968433154',
    // config.headers["communityid"] = '9d90a9a5fe789802f51d3227a214321e'
    return config
  }, function (error) {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  (res) => {
    Toast.clear()
    return res.data
  },
  (error) => {
    console.log(error)
    if (
      error.response &&
      ( error.response.status == 500 ||
        error.response.status == 502 ||
        error.response.status == 504 ||
        error.response.status == 404 ||
        error.response.status == 500)
    ) {
      if (error.response.data.code == "main-500") {
        error = 'main-500'
      } else {
        error = error.response.data.message
      }
      // return Promise.reject(error)
      // error = error.response.data.message
    } else if (error.response && error.response.status == 403) {
      error = "权限不足,请联系管理员!"
    } else if (error.message.includes("timeout")) {
      error = "请求超时"
    } else {
      error = "未知错误!"
    }
    Toast.clear()
    return Promise.reject(error)
  }
)

export default service
